const modulos = (state) => state.modulos;

const hasAnyAccess = (state) => state.hasAnyAccess;

const moduloAtivo = (state) => state.moduloAtivo;

const carregandoModulos = (state) => state.carregandoModulos;

const trocandoModulo = (state) => state.trocandoModulo;

const moduloAtualDetalhes = (state) => {
    if (!state.moduloAtivo) return null;
    return state.modulos.find(m => m.id == state.moduloAtivo) || null;
};

// ─── CRUD admin ──────────────────────────────────────────────────────────────

const listaDeModulos = (state) => state.items || [];
const loadingModulo = (state) => state.buscando;
const paginacao = (state) => state.paginacao || null;
const moduloSelecionado = (state) => state.selecionado || {};
const listaDeUsuarios = (state) => state.usuarios || [];

export {
    modulos,
    hasAnyAccess,
    moduloAtivo,
    carregandoModulos,
    trocandoModulo,
    moduloAtualDetalhes,
    listaDeModulos,
    loadingModulo,
    paginacao,
    moduloSelecionado,
    listaDeUsuarios
}